import api from './api';
import StorageService from './StorageService';

const PayoutService = {
    getAllPayouts: async (page = 1, limit = 10, filters = {}) => {
        try {
            const { branchId, staffId, memberId, vendorId, projectId, expenditureTypeId, paymentMode, status, startDate, endDate } = filters;
            let url = `/payOut?page=${page}&limit=${limit}`;
            if (branchId) url += `&branchId=${branchId}`;
            if (staffId) url += `&staffId=${staffId}`;
            if (memberId) url += `&memberId=${memberId}`;
            if (vendorId) url += `&vendorId=${vendorId}`;
            if (projectId) url += `&projectId=${projectId}`;
            if (expenditureTypeId) url += `&expenditureTypeId=${expenditureTypeId}`;
            if (paymentMode) url += `&paymentMode=${paymentMode}`;
            if (status) url += `&status=${status}`;
            if (startDate) url += `&startDate=${startDate}`;
            if (endDate) url += `&endDate=${endDate}`;

            const res = await api.get(url);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to fetch payouts');
            }
            throw new Error('Unable to connect to server');
        }
    },

    getPayoutById: async (id) => {
        try {
            const res = await api.get(`/payOut/${id}`);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to fetch payout');
            }
            throw new Error('Unable to connect to server');
        }
    },

    createPayout: async (data) => {
        try {
            const payload = { ...data, createdBy: StorageService.loginData()?.employeeId };
            const res = await api.post('/payOut', payload);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to create payout');
            }
            throw new Error('Unable to connect to server');
        }
    },

    updatePayout: async (id, data) => {
        try {
            const payload = { ...data, updatedBy: StorageService.loginData()?.employeeId };
            const res = await api.put(`/payOut/${id}`, payload);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to update payout');
            }
            throw new Error('Unable to connect to server');
        }
    },

    updateStatus: async (id, status) => {
        try {
            const res = await api.patch(`/payOut/${id}/status`, { status, updatedBy: StorageService.loginData()?.employeeId });
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to update payout status');
            }
            throw new Error('Unable to connect to server');
        }
    }
};

export default PayoutService;
